import { useDroppable } from "@dnd-kit/core";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  OnClickLink,
  cn,
} from "@sorcery/ui";
import { useRouter } from "next/router";

export const DeckBreadcrumbs = ({ activeName }: { activeName?: string }) => {
  const { query: routerParams, push } = useRouter();

  const { isOver, setNodeRef } = useDroppable({
    id: "*",
  });

  return (
    <div className="w-full duration-500 animate-in fade-in pb-4">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem
            ref={setNodeRef}
            className={cn("px-1 rounded-sm", isOver && "bg-white/70 text-black")}
          >
            <BreadcrumbLink asChild>
              <OnClickLink
                onClick={() => {
                  // biome-ignore lint/performance/noDelete: <explanation>
                  delete routerParams.folder;
                  void push(
                    {
                      query: {
                        ...routerParams,
                      },
                    },
                    undefined,
                    {
                      shallow: true,
                    },
                  );
                }}
                className="hover:text-primary"
              >
                All Decks
              </OnClickLink>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>{activeName}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};
